import type { FaireProductEntity } from "../../entity_types/product";

export const p_4x7qbqtdxc: FaireProductEntity = {
  token: "p_4x7qbqtdxc",
  type: "product",
  name: "MINERAL WASHED TOP AND PANTS RIB SETS",
  brandToken: "b_q33jfvrznn",
  brandName: "Sewn and Seen",
  imageUrl:
    "https://cdn.faire.com/fastly/ffd6de3e31664d4bd6636bf142fb40b051f563791f7b0fccd9b22838ac00423b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/519adf5b890dc00f42eecbab6fa426457552ffe2d4ddf06b5b36a0e0b0eec798.jpeg",
    "https://cdn.faire.com/fastly/69a4e7952e4677dba77dc401c314f95668f3ccd0ea851f4aed92c4e1ff9e596a.jpeg",
    "https://cdn.faire.com/fastly/3733eb5dce9873725e9426cf76cecb9505dd723d46de079e896a0e71f7f0660f.jpeg",
    "https://cdn.faire.com/fastly/42d1bba4e44f28bd98b39f327e66e78c59f9fab9698f9476b50c308eef584480.jpeg",
    "https://cdn.faire.com/fastly/b2a7f881ec19cdc6e5d201543e611d0ca5614eb078a6a2fb89916966f918af69.jpeg",
    "https://cdn.faire.com/fastly/2c7e5cd37d6fbdd1247da22f83a63e03b00327e6844165919cb807aa641eebbb.jpeg",
    "https://cdn.faire.com/fastly/9d5ef9739a10e21d1ef7761396d231149ff16992cb25094987bd13f43c4384c2.jpeg",
    "https://cdn.faire.com/fastly/9dffcb8a03ceded5d279bf2b87c8185785eff25a6c1b7dcc90d4633f005f8abd.jpeg",
    "https://cdn.faire.com/fastly/38dec36ac640025dafc20698964272d0a59886d1cbb163f9fcf4b172438fdda0.jpeg",
    "https://cdn.faire.com/fastly/b2c97c8335915b1a3de51afba0e60b461186f2e8a135bcdc4c53db7f1af4c516.jpeg",
    "https://cdn.faire.com/fastly/801a1ad693c85ea47d35bfabf2a353e6ab8b8655d381f2d5cc8332ccaedb7ecb.jpeg",
    "https://cdn.faire.com/fastly/de8713ded59a57c39f17560eb8fa43e860f393664011623d8ef3c51ab1175bfe.jpeg",
    "https://cdn.faire.com/fastly/68f577dbf409b09549dfa4d7ecc49e80cc6f46e9252230b6cdf025d4cfe2e46d.jpeg",
    "https://cdn.faire.com/fastly/c3291985a2bf9e6042118cc4f38a04ed210832f4273d985f373d4e0a21e759a1.jpeg",
    "https://cdn.faire.com/fastly/a6b02996fb9021c48e6b4fcdc7eaf443a7d6cf9658a3f3112f182e23dda21386.jpeg",
    "https://cdn.faire.com/fastly/c4e0850385913aeb8aea08632f5637f2d28189b4d3376a3c5c27d969103ae5e3.jpeg",
    "https://cdn.faire.com/fastly/48aa5f1da7ea1e18ef1254ebceb7058cf33a92cfb78cc7c38771e14596029876.jpeg",
    "https://cdn.faire.com/fastly/08266ffb75f1374fcd8615d4012e7c3d5195b49d92e70848e72c65d653b1e547.jpeg",
    "https://cdn.faire.com/fastly/33c74cb7a50deb63fe1cb45429cc90b6bf24b7b0ff80c94a3c763602f2bd7557.jpeg",
    "https://cdn.faire.com/fastly/278212a0457deaa8ba4b598ca3bd5b6c6dd9c1ae02e6d9e8cb1db79421a5147d.jpeg",
    "https://cdn.faire.com/fastly/80d589f7ca665bdc714e72fa4e2802c33a4ef3c1761e322d3d456e20b820cc0c.jpeg",
    "https://cdn.faire.com/fastly/ba8f24783c6a18b6e27dbcf639fec8496dd4678bab6d96c8b2643b96910d5531.jpeg",
    "https://cdn.faire.com/fastly/21e89ccc5c8bb227ce4156958ce076e304919b0adf2f2babe00f49014e4315f8.jpeg",
    "https://cdn.faire.com/fastly/80498b86f5efabbf853975c17557208801b93dfb3392a5f9c1fb1226e0d0a2cc.jpeg",
    "https://cdn.faire.com/fastly/b74b69d5f3b63627f2f8643e122cb8b331b4b5d3da28043dd3390ef40e57b0c0.jpeg",
    "https://cdn.faire.com/fastly/41c901b0f0d2919ac5978e472be922907ad25edef8fb77abc18fb0a2822dabc6.jpeg",
    "https://cdn.faire.com/fastly/a76ae2ad696a40a7cd1a2762bc2ba6b40823c296ebcbd44ec31cf4c3f83c3062.jpeg",
    "https://cdn.faire.com/fastly/4dfdb831d8bec1e0d7f93441e6954227e27dc7eb588b08cbe3b94e592e03cfc9.jpeg",
    "https://cdn.faire.com/fastly/407642d3de96ca44fcceeaa5ba4f98e68268d82ffcc6fcc87cee8e979f6d3ef8.jpeg",
    "https://cdn.faire.com/fastly/9bb8058455318badbb925b9b17b5e9be14d73f9685b8b9f96ebd7fb01edae583.jpeg",
    "https://cdn.faire.com/fastly/44b1ba327c418b78c7f78a492d7de8b8957d83e00f5a099fac1563c6b57cc4f1.jpeg",
    "https://cdn.faire.com/fastly/d41edc57249aa777b27c4a2bc2e91f670cef05a1798972e11760e689f91f8d7a.jpeg",
    "https://cdn.faire.com/fastly/ce2788c24c5c1b68c096bc8c84e5119e9521d9cd295eaa5eb5160ddd6a694b04.jpeg",
    "https://cdn.faire.com/fastly/b7bc61a953a067e64e85c1d3efaccfa1f51eaca40947936129bc0099d7cb6f4d.jpeg",
    "https://cdn.faire.com/fastly/18993ea6ced991becd8d9159dc3fcbb960c206fec60f1090a068aaacdb9d5bef.jpeg",
    "https://cdn.faire.com/fastly/77d9c34758286c319b10f6df1683d5139896e14fbd50108a73272a65fb88d808.jpeg",
    "https://cdn.faire.com/fastly/31e652eda8b34427d782d7dbf922670afba409539595cb6c850c95c3823b2128.jpeg",
    "https://cdn.faire.com/fastly/eb7729b4a0b0a095bca126f2b2de714b7bcbff42e65d762cc66204f6af4fc32b.jpeg",
    "https://cdn.faire.com/fastly/c7a07f2e599c68003dff2448825e47adc8dff974f0d543c0338936286b3d24a4.jpeg",
    "https://cdn.faire.com/fastly/b7281fe61682ce0530038dfef2da7c74c99092970e9c5129ac560b63637a3787.jpeg",
    "https://cdn.faire.com/fastly/5888760fd1ae0fdfde43788ec6d06d0af8f220b0615f868481bb475eae4269e5.jpeg",
    "https://cdn.faire.com/fastly/8b0e22fefa3d675f6b74c2a78fd021591c4710da30b9122ee7d9753b16e5f1e4.jpeg",
    "https://cdn.faire.com/fastly/7805c9de9c86bef93bc2a3c46664660320e681df6019a4299e3e3842a5d6195b.jpeg",
  ],
  priceDollars: 196.5,
  description:
    "The top features a ribbed design with a round neckline and cap sleeves, while the pants have a relaxed fit and an elastic waistband for a comfortable fit. The mineral-washed fabric adds a touch of edginess to the sets, making them perfect for dressing up or down.",
  tags: [],
  msrpDollars: 393,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:13.932Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
